import React from 'react';
import { useTranslation } from 'react-i18next';
import PremiumIcon from '../../../Icons/Premium';
import StatLayout from '../StatLayout';
import BiClickLogger from '../../../biLogger/BiClickClogger';
import { BiEventType } from '../../../biLogger/constants';
export var DownloadablePcpStat = function (_a) {
    var deviationId = _a.deviationId, url = _a.url;
    var t = useTranslation().t;
    return (React.createElement(BiClickLogger, { eventData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviationId,
            ispaiddownload: 1,
        } },
        React.createElement(StatLayout, { icon: PremiumIcon, tooltip: {
                tooltipKey: t('actionbar.pcp.owned'),
            }, link: {
                href: url,
                target: '_blank',
                isDownload: true,
            } })));
};
DownloadablePcpStat.displayName = 'DownloadablePcpStat';
export default DownloadablePcpStat;
//# sourceMappingURL=DownloadablePcpStat.js.map